module.exports = __webpack_public_path__ + "img/sandwich.5e2cbf1c.gif";